import React from 'react'
import styles from '../styles'
import { ContactUs, Courses, Register } from './'
import homePic from '../assets/homePic.webp'

const Home = () => {
  return (
    <div className='w-full h-full'>
      <div className={`w-full md:h-full h-[95vh] relative flex flex-col flex-1 items-center justify-start`}>
        <img 
          src={homePic} 
          alt="Home Pictures" 
          className='w-full h-full object-cover'
        />
        <div className='absolute flex flex-1 flex-col items-start justify-center p-2 md:px-[30px] bg-primary bg-opacity-50 h-full w-full'>
          <h1 className={`${styles.heading2}`}>Mlimi Online Learning Platform</h1>
          <p className={`md:w-[475px] w-[375px] bg-primary bg-opacity-20 p-3  ${styles.paragraph}`}>
            Is the first platform in Malawi that uses Information Technology  to create opportunity 
            for young people to learn and have easy access
            to agricultural and extension services. It also conducts field demonstrations in demonstration plots situated within the country.
          </p>
          <div className='flex flex-row gap-x-5 items-center justify-center mt-5 text-white p-3'>
            <a href="#register" className='bg-green-600 text-bold px-4 p-2 border-2 border-white'>Register</a>
            <a href="#contactUs" className='border-2 border-white p-2 px-4 font-semibold'>Contact Us</a>
          </div>
        </div>
        
      </div>

      <div id='courses' className=''>
        <Courses />
      </div>

      <hr className='border-1 border-gray-500 m-3'/>

      <div id='register'>
        <Register />
      </div>

      <hr className='border-1 border-gray-500 m-3'/>

      <div id='contactUs'>
        <ContactUs />
      </div>
    </div>
  )
}

export default Home
